export default {"src":"/_next/static/media/greenhouse-icon-lg.dc171003.svg","height":80,"width":80};